import { getArticles } from "../../../helpers";

export const isUserAdmin = async (token) => {
    const adminStatus = await getArticles(token);
    return !!adminStatus;
};